<template>
  <div class="login-form">
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <ValidationProvider
          class="form-group"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="E-mail ou CPF">
            E-mail ou CPF
          </label>
          <div
            :class="errors.length > 0 ? '--input-error-border' : '--input-default-border'"
            class="input--wrapper"
          >
            <input
              autocomplete="off"
              v-model="user"
              name="E-mail ou CPF"
              type="text"
              placeholder="000.000.000-01"
            >
          </div>
          <span class="input-error">
            {{ errors[0] }}
          </span>
        </ValidationProvider>

        <ValidationProvider
          class="form-group --domain"
          rules="required"
          v-slot="{ errors }"
        >
          <label for="senha">
            Senha
          </label>
          <div
            :class="errors.length > 0 ? '--input-error-border' : '--input-default-border'"
            class="input--wrapper --password"
          >
            <input
              autocomplete="off"
              v-model="password"
              name="Senha"
              :type="passwordInputType"
            >
            <span
              @click.prevent="showPassword"
              :class="{ 'icon-eye-show': isPasswordVisible, 'icon-eye-hide': !isPasswordVisible }"
              title="Mostrar senha"
            />

          </div>
          <span class="input-error">
            {{ errors[0] }}
          </span>
          <a
            :href="recoverUrl"
            target="_self"
          >
            Esqueci minha senha
          </a>
        </ValidationProvider>

        <button
          :class="invalid ? 'button-disable' : 'button-enable'"
          :disabled="invalid"
        >
          <clip-loader
            v-if="loading"
            :loading="loading"
            :color="color"
            :size="size"
          />
          <span v-else>
            Entrar
          </span>
        </button>

        <button class="button-create">
          <a
            :href="createAccount"
            target="_self"
          >
            Criar uma conta
          </a>
        </button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { validateCPF } from '@/helpers/string'
import { tokenDecoder } from '@/helpers/token.js'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ClipLoader
  },
  data () {
    return {
      user: '',
      password: '',
      isPasswordVisible: false,
      loading: false,
      color: "#FFFFFF",
      colorGrey: "#394557",
      size: '20px'
    }
  },
  created () {

  },
  computed: {
    passwordInputType () {
      return this.isPasswordVisible ? 'text' : 'password'
    },
    recoverUrl () {
      return `${process.env.ACCOUNTS}/recuperar-senha`
    },
    createAccount () {
      return `${process.env.ACCOUNTS}/cadastro`
    }
  },
  methods: {
    ...mapActions('Users', [
      'postUserLogin',
      'getRoles'
    ]),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    showPassword () {
      this.isPasswordVisible = !this.isPasswordVisible
    },
    async onSubmit () {

      this.loading = true
      const isCPF = validateCPF(this.user);
      const loginType = isCPF ? 'document' : 'email';

      try {
        const response = await this.postUserLogin(
          {
            [loginType]: this.user,
            password: this.password
          }
        )
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          let token = response.data.token
          const decoder = tokenDecoder(token)
          if (
            !(decoder.auth.includes('user_gambit') ||
            decoder.auth.includes('administrator_gambit'))
          ) {
            this.$router.push({
              name: 'Login'
            })
            this.loading = false
            this.toaster('Você não possui acesso a ferramenta.', 'red accent-2', true)

          } else {
            this.loading = false
            this.$router.push({
              name: 'Home'
            })
          }
        }
      } catch (error) {
        this.loading = false
        this.toaster(error.message, 'red accent-2', true)
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
  }
}
</script>

<style lang="scss">
.login-form {
  margin-top: 28px;
  width: 100%;

  .form-group {
    display: flex;
    flex-direction: column;

    label {
      color: var(--neutral-black);
      font-family: var(--dm-sans-medium);
      margin-bottom: 10px;
      font-style: normal;
      font-weight: bold;
      font-size: 14.222px;
      line-height: 16px;
      letter-spacing: -0.002em;
    }

    input {
      height: 40px;
      padding: 0.75rem;
      width: 100%;

      color: var(--grey-day-060);
      font-size: .875rem;
      font-family: var(--dm-sans-regular);
    }

    .--input-default-border {
      border-radius: 4px !important;
      border: 2px solid var(--grey-day-030);
      margin-bottom: 14px;
    }

    .--input-error-border {
      border-radius: 4px;
      border: 2px solid var(--dark-red);
    }

    .input-error {
      font-size: .75rem;
      text-align: left;
      margin-top: 4px;
      font-family: var(--dm-sans-bold);
      font-weight: 600;
      color: var(--red);
    }

    .--password {
      position: relative;

      span {
        position: absolute;
        top: 12px;
        right: 12px;
      }
    }

    a {
      margin-bottom: 18px;
      text-align: right;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      font-style: normal;
      font-weight: 500;
      font-size: 14.222px;
      line-height: 19px;
    }

    a:visited {
      color: var(--dark-grey);
    }

    .--domain {
      margin-top: 16px;
    }
  }

  button {
    border: none;
    border-radius: 4px;
    color: var(--neutral-grey);
    font-family: var(--dm-sans-medium);
    font-size: 1rem;
    font-weight: 500;
    height: 56px;
    width: 704px;
    margin-top: 8px;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;

    a {
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
    }

    a:visited {
      color: var(--dark-grey);
    }
  }

  .button-enable {
    background: var(--dark-red);
    color: var(--white);
    cursor: pointer;
  }

  .button-create {
    border-radius: 4px;
    border: 1px solid var(--grey-day-030);
    box-sizing: border-box;
    background: var(--white);
    color: var(--dark-grey);
    cursor: pointer;
  }

  .button-disable {
    background: var(--light-grey);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LoginForm/index.vue